<!-- 
Vendor Edit 
	"./layouts/Dashboard.vue" .
 -->


<template>
  <div v-cloak>
    <div style="height: 50%; width: 100%">
      <loading :is-loading="isLoading"></loading>
    </div>
    <!-- header -->
    <div class="mb-50">
      <div class="mx-auto m-50" style="max-width: 800px">
        <div
          class="profile-nav-bg"
          style="background-image: url('images/bg-profile.jpg')"
        ></div>
        <a-form
          id="main-form"
          :form="form"
          :bordered="true"
          class="header-solid"
          :bodyStyle="{ padding: 0 }"
          @submit="handleSubmit"
        >
          <a-row type="flex" align="middle">
            <a-col :span="24" :md="12" class="col-info">
              <br />
              <div class="avatar-info">
                <h4 class="font-semibold m-0">
                  {{ vendor.vendorName }}
                </h4>
              </div>
            </a-col>
          </a-row>
          <br />

          <h5 class="mb-0">Vendor Information</h5>

          <a-row :gutter="[24]">
            <a-col span="12">
              <a-form-item class="mb-10" label="Vendor Name" :colon="false">
                <a-input
                  v-decorator="[
                    'vendorName',
                    {
                      initialValue: vendor.vendorName,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide vendor name',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Smith Painting LLC"
                />
              </a-form-item>

              <a-form-item class="mb-10" label="Tax ID" :colon="false">
                <a-input
                  v-decorator="[
                    'taxID',
                    {
                      initialValue: vendor.taxID,
                      rules: [
                        {
                          required: true,

                          message: 'Please provide a tax ID',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. xx-xxxxxxx"
                />
              </a-form-item>
            </a-col>
            <a-col span="12">
              <a-form-item class="mb-10" label="Vendor Type" :colon="false">
                <a-select
                  v-model="vendor.vendorType"
                  default-value="Property Manager"
                >
                  <a-select-option value="Property Manager"
                    >Property Manager</a-select-option
                  >
                  <a-select-option value="Landscaping"
                    >Landscaping</a-select-option
                  >
                  <a-select-option value="Maintenance"
                    >Maintenance</a-select-option
                  >
                  <a-select-option value="Construction"
                    >Construction</a-select-option
                  >
                  <a-select-option value="Accounting"
                    >Accounting</a-select-option
                  >
                  <a-select-option value="Legal">Legal</a-select-option>
                  <a-select-option value="Other">Other</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- contact info -->
          <h5 class="mb-0">Address Information</h5>
          <a-row :gutter="[24]">
            <a-col :span="12">
              <a-form-item class="mb-10" label="Street 1" :colon="false">
                <a-input
                  v-decorator="[
                    'address1',
                    {
                      initialValue: vendor.addressDetails.address1,
                      rules: [
                        {
                          required: true,
                          message: 'Please provide address name',
                        },
                      ],
                    },
                  ]"
                  validate-status="error"
                  placeholder="eg. 1006 Summit Way"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="City" :colon="false">
                <a-input
                  v-decorator="[
                    'city',
                    {
                      initialValue: vendor.addressDetails.city,
                      rules: [
                        {
                          required: true,

                          message: 'Please provide a city',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. Austin"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="Street 2" :colon="false">
                <a-input
                  v-decorator="[
                    'address2',
                    {
                      initialValue: vendor.addressDetails.address2,
                      rules: [
                        { required: false, message: 'Please provide a city' },
                      ],
                    },
                  ]"
                  placeholder="eg. Suite 46"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="Zip" :colon="false">
                <a-input
                  v-decorator="[
                    'zipCode',
                    {
                      initialValue: vendor.addressDetails.zipCode,
                      rules: [
                        {
                          required: true,
                          tpattern: new RegExp(/^\d+$/),
                          message: 'Please provide a Valid ZipCode',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. 78669"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="States" :colon="false">
                <a-select
                  v-decorator="[
                    'state',
                    {
                      initialValue: vendor.addressDetails.state,
                      rules: [
                        { required: true, message: 'Please provide a state' },
                      ],
                    },
                  ]"
                  default-value="test"
                >
                  <a-select-option
                    v-for="state in vendor.states"
                    :key="state"
                    :value="state"
                  >
                    {{ state }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <h5 class="mb-0">Contact Information</h5>
          <a-row :gutter="[24]">
            <a-col :span="12">
              <a-form-item class="mb-10" label="Contact Phone 1" :colon="false">
                <a-input
                  v-decorator="[
                    'phone',
                    {
                      initialValue: vendor.contactDetails.phone,
                      rules: [
                        {
                          pattern: new RegExp(/^(\d+-?)+\d+$/),
                          required: true,
                          message: 'Please provide a phone number',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. 425-233-7488"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="fax Number" :colon="false">
                <a-input
                  v-decorator="[
                    'fax',
                    {
                      initialValue: vendor.contactDetails.fax,
                      rules: [
                        {
                          required: false,
                          pattern: new RegExp(/^(\d+-?)+\d+$/),
                          message: 'Please provide a fax number',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. 425-233-7457"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="Contact Phone 2" :colon="false">
                <a-input
                  v-decorator="[
                    'phone2',
                    {
                      initialValue: vendor.contactDetails.phone2,
                      rules: [
                        {
                          required: false,
                          pattern: new RegExp(/^(\d+-?)+\d+$/),
                          message: 'Please provide a valid phone number',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. 425-233-7488"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="mb-10" label="Contact Email" :colon="false">
                <a-input
                  v-decorator="[
                    'email',
                    {
                      initialValue: vendor.contactDetails.email,
                      rules: [
                        {
                          required: true,
                          type: 'email',
                          message: 'Please provide a valid email',
                        },
                      ],
                    },
                  ]"
                  placeholder="eg. mary@property361.com"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <h5 class="mb-0">Vendor Attachments</h5>
          <a-row :gutter="[24]">
            <a-col :span="24">
              <a-form-item
                class="mb-10"
                label="Any helpful insurance attachments for this vendor"
                :colon="false"
              >
                <a-upload
                  name="avatar"
                  list-type="picture-card"
                  class="projects-uploader"
                  :show-upload-list="false"
                  style="height: 150px"
                >
                  <img v-if="false" src="" alt="avatar" />
                  <div v-else>
                    <div class="ant-upload-text font-regular text-muted">
                      Drop files here to upload
                    </div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="[24]">
            <a-col :span="24" class="text-right">
              <p v-if="success" class="successful">
                Vendor has been successfully updated.
              </p>
              <a-button
                type="primary"
                @click="$router.go(-1)"
                class="px-25 m-5"
              >
                CANCEL
              </a-button>
              <a-button type="primary" @click="handleSubmit()" class="px-25">
                {{ submitState }}
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "../../scss/pages/_vendorEdit.scss";
import loading from "../../components/Cards/CardPleaseWait.vue";

export default {
  components: {
    loading: loading,
  },
  data() {
    return {
      //vendor: {},
      isLoading: true,
      currentRoute: window.location.pathname,
      success: false,
      submitState: "SAVE",
      form: this.$form.createForm(this, { name: "editVendor" }),
    };
  },
  methods: {
    //Handles input validation after submission.
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.submitState = "Please Wait";
          this.vendor.updatedDate = this.updateDate();
          this.$store
            .dispatch("vendors/updateVendor", this.vendor)
            .then(() => {
              this.success = true;
              this.submitState = "SAVE";
              (res) => {
                console.log(res);
              };
            })
            .catch((error) => {
              console.log(error.response);
            });
        }
      });
    },
    updateDate() {
      var currentdate = new Date();
      currentdate.getFullYear() +"-" +
        (currentdate.getMonth() + 1) +"-" +
        currentdate.getDate() +"T" +
        currentdate.getHours() +":" +
        currentdate.getMinutes() +":" +
        currentdate.getSeconds();
      return currentdate;
    },
  },
  computed: {
    vendor: {
      get() {
        return this.$store.state.vendors.vendor;
      },
    },
  },

  created() {
    this.$store
      .dispatch(`vendors/getVendor`, this.$route.params.id)
      .then(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
</style>
